import React from "react";
import isContentDownloadable from "../../helpers/isContentDownloadable";
import styles from "../../styles/ContentList.module.scss";
import Button from "@src/components/UIElements/Button";
import { CONTENT_TYPE } from "../../store/constants";
import { getAwsAssets, hitHapticFeedback } from "@src/utils/index";
import { Image } from "@src/components/Image";
import ListItemThumbnail from "./ListItemThumbnail";
import ListItemDetails from "./ListItemDetails";
import { useRouter } from "@src/lib/router";
import isVideoExhausted from "../../helpers/isVideoExhausted";
import {
  showContentLockedBottomSheetAction,
  showCourseLockedBottomSheetAction,
  showLockedFreeCourseBottomSheetAction,
  showTestIsLockedBottomSheetAction,
  showTestIsTemporarilyLockedBottomSheetAction,
  showTestIsTemporarilyLockedTimingBottomSheetAction,
  showViewsExhaustedBottomSheetAction,
  toggleVideoBottomSheet,
} from "@src/components/BottomSheets/store/actions";
import { useDispatch, useSelector } from "react-redux";
import { t } from "i18next";
import handleOpenContent from "../../helpers/handleOpenContent";
import ContentDownloader from "./ContentDownloader";
import { funnelTrackAction } from "@src/components/Tabs/Overview/store/actions.js";
import {
  installmentsAlertStateEnum,
  trackIDMap,
} from "../../../Overview/store/constants";
import { getUserAgent } from "@src/utils/getAxiosConfig";
import { USER_AGENT_STRING } from "@src/utils/constants";
import { safeJsonParse } from "@src/utils/safeJsonParse";

const ListItem = (
  {
    content,
    getOfflineDownloadedItemProgress,
    getOfflineDownloadedItemState,
    handleGetOfflineDownloadList,
    handleSetCheckProgressInterval,
    handleClearCheckProgressInterval,
    isTrialContent = false
  },
  ref
) => {
  // NEXTJS ROUTER
  const router = useRouter();

  // REDUX DISPATCH
  const dispatch = useDispatch();
  const isFreeCourse = useSelector((state) => state?.overviewReducer?.overViewDetails?.course?.metaData?.isFreeCourse) || 0;

  const isUserSubscribedToFreeCourse = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.metaData
        ?.isUserSubscribedToFreeCourse
    ) || 0;
  const canRePurchaseFreeCourse = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.metaData
        ?.canRePurchaseFreeCourse
    );

  // METHOD TO REDIRECT FOLDER ROUTE
  const changeFolderRoute = (folderId, contentCourseId, isGlobalCourse) => {
    let courseId = router.query.courseId;
    let urlParams = new URLSearchParams(window.location.search);
    let originalCourseId = urlParams?.get("originalCourseId");
    let route = `/${courseId}/folder/${folderId}?isTrialContent=${isTrialContent ? 1 : 0}`;
    if (originalCourseId) {
      route = `/${courseId}/folder/${folderId}?originalCourseId=${originalCourseId}&isTrialContent=${isTrialContent ? 1 : 0}`;
    }
    if (isGlobalCourse === 1) {
      route = `/${contentCourseId}/folder/${folderId}?originalCourseId=${courseId}&isTrialContent=${isTrialContent ? 1 : 0}`;
    }
    router.push(route);
  };

  // FETCHING STATES FROM REDUCER
  const isCourseLocked = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.installments
        ?.installmentAlertState
  );
  const state = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course
  );

  const orgId = useSelector((state) => state?.overviewReducer?.overViewDetails?.course
  ?.metaData?.orgId) ;

  // HANDLING CLICK ON ITEM
  const handleItemClicked = (content) => {
    localStorage.setItem("currentItem", JSON.stringify(content));
    // console.log(router.query);
    hitHapticFeedback();
    dispatch(
      funnelTrackAction({
        type: trackIDMap.contentView,
        isPurchased:
          state?.installments?.paidInstallmentSummary?.isPaymentComplete ===
            1 || state?.metaData?.isPurchased === 1,
        courseId: router?.query?.courseId,
        folderId: router?.query?.folderId || 0,
        contentId: content.id,
        contentType: content.contentType,
      })
    );
    if (
      isCourseLocked === installmentsAlertStateEnum.COURSE_LOCKED &&
      content?.isLocked
    ) {
      dispatch(showCourseLockedBottomSheetAction(true));
      return;
    }
    const { id, contentType, contentCourseId, isGlobalCourse } = content;
    switch (contentType) {
      case CONTENT_TYPE.FOLDER: {
        changeFolderRoute(id, contentCourseId, isGlobalCourse);
        break;
      }
      case CONTENT_TYPE.LIVE_CLASS:
      case CONTENT_TYPE.VIDEO: {
        // SHOWING CONTENT IS LOCKED BOTTOM SHEET IF LOCKED
        // if (content?.isLocked)
        if (
          content.isScheduled ||
          (!content.isPurchased && content?.isLocked)
        ) {
          if(isFreeCourse && (isUserSubscribedToFreeCourse || !canRePurchaseFreeCourse)){
            dispatch(showLockedFreeCourseBottomSheetAction(true));
          }else{
            dispatch(showContentLockedBottomSheetAction(true));
          }
        }
        // IF VIDEO LIMIT IS EXHAUSTED OPENING EXHAUSTED BOTTOMSHEET
        else if (isVideoExhausted(content)) {
          dispatch(showViewsExhaustedBottomSheetAction(true));
        } else {
          handleViewContentItem(content);
        }
        break;
      }
      case CONTENT_TYPE.DOCUMENT: {
        // SHOWING CONTENT IS LOCKED BOTTOM SHEET IF LOCKED
        // if (content?.isLocked)
        if (
          content.isScheduled ||
          (!content.isPurchased && content?.isLocked)
        ) {
          if(isFreeCourse && (isUserSubscribedToFreeCourse || !canRePurchaseFreeCourse)){
            dispatch(showLockedFreeCourseBottomSheetAction(true));
          }else{
            dispatch(showContentLockedBottomSheetAction(true));
          }
        } else handleViewContentItem(content);
        break;
      }
      case CONTENT_TYPE.TEST: {
        // SHOWING TEST IS TEMPORARILY LOCKED BOTTOM SHEET IF SCHEDULED AND HAS START AND END DATE
        // if (
        //   content?.isLocked &&
        //   content?.isScheduled &&
        //   content?.scheduledFromDateText &&
        //   content?.scheduledToDateText
        // ) {
        //   dispatch(
        //     showTestIsTemporarilyLockedTimingBottomSheetAction(true, {
        //       startDate: content?.scheduledFromDateText,
        //       endDate: content?.scheduledToDateText,
        //     })
        //   );
        // }
        // // SHOWING TEST IS TEMPORARILY LOCKED BOTTOM SHEET IF SCHEDULED BUT NOT HAVE START AND END DATE
        // else if (content?.isLocked && content?.isScheduled) {
        //   dispatch(showTestIsTemporarilyLockedBottomSheetAction(true));
        // }
        // SHOWING TEST IS LOCKED BOTTOM SHEET IF LOCKED
        // else
        if (
          content.isScheduled ||
          (content?.isPurchased && content?.isLocked) ||
          (!content.isPurchased && content?.isLocked)
        ) {
          if(isFreeCourse && (isUserSubscribedToFreeCourse || !canRePurchaseFreeCourse)){
            dispatch(showLockedFreeCourseBottomSheetAction(true));
          }else{
            dispatch(showTestIsLockedBottomSheetAction(true));
          }
        }
        // OPENING THE TEST STATS PAGE IF ALREADY ATTEMPTED
        else if (
          content?.typeOfTest === 2 &&
          content?.numberOfAttemptsRemaining === 0
        ) {
          handleViewContentItem(content);
        } else if (
          content?.scoredMarks ||
          content?.scoredMarks === 0 ||
          (content?.numberOfAttemptsRemaining === 0 &&
            content?.totalAttempts !== -1)
        ) {
          let courseId = content.isGlobalFolderContent ? content.globalFolderCourseId : router?.query?.courseId;
          router.push(
            `/${courseId}/teststats/${content?.testId}/${content?.id}`
          );
        }
        // ELSE ATTEMPTING TEST
        else {
          handleViewContentItem(content);
        }
        break;
      }
    }
    // console.log(content);
  };

  // // FUNCTION TO CHECK IF DOWNLOAD ICON HAS TO BE SHOWN
  // const showDownloadIcon = (content) => {
  //   if (isNaN(getOfflineDownloadedItemState(content?.url))) return true;
  //   switch (getOfflineDownloadedItemState(content?.url)) {
  //     case CONTENT_DOWNLOAD_STATUS.DOWNLOAD_PAUSE:
  //     case CONTENT_DOWNLOAD_STATUS.DOWNLOAD_FAILED:
  //     case CONTENT_DOWNLOAD_STATUS.DOWNLOAD_REMOVE:
  //     case CONTENT_DOWNLOAD_STATUS.DOWNLOAD_CANCEL:
  //     case CONTENT_DOWNLOAD_STATUS.DOWNLOAD_UNKNOWN: {
  //       return true;
  //     }
  //   }
  //   return false;
  // };

  // FUNCTION TO VIEW CONTENT ITEM
  const handleViewContentItem = (content) => {
    const isMobileAndroid = getUserAgent() === USER_AGENT_STRING.ANDROID;
    const isCorruptedAndroidVersion = safeJsonParse(window?.androidData, {
      source: "ListItem [window.androidData]",
      fallback: null,
    });
    console.log(isCorruptedAndroidVersion, 'isCorruptedAndroidVersion');
    const enableWebVideoPlayer = isMobileAndroid &&  isCorruptedAndroidVersion?.appVersion === "1.6.1.3";

    if (content.contentType === CONTENT_TYPE.VIDEO && enableWebVideoPlayer) {
      dispatch(toggleVideoBottomSheet({
        value: true,
        data: content
      }));
    } else {
      handleOpenContent({
        ...content,
        courseId: +router?.query?.courseId,
        originalCourseId: parseInt(router?.query?.originalCourseId),
      });
    }
  };

  // FUNCTION TO ATTEMPT / REATTEMPT TEST
  const handleAttemptTest = (content) => {
    if (content.isScheduled || (!content.isPurchased && content?.isLocked)) {
      localStorage.setItem("currentItem", JSON.stringify(content));
      dispatch(showTestIsLockedBottomSheetAction(true));
    } else {
      handleViewContentItem(content);
    }
  };

  return (
    <div
      className={styles.contentList__item}
      ref={ref}
      onClick={() => handleItemClicked(content)}
    >
      <ListItemThumbnail content={content} />
      <div className={styles.contentList__item__content}>
        <ListItemDetails
          content={content}
          className={styles.contentList__item__content__text}
        />
        <div
          className={styles.contentList__item__content__button}
          style={
            content?.contentType === CONTENT_TYPE.FOLDER
              ? { paddingTop: "6px" }
              : {}
          }
        >

          {content?.isLocked || isVideoExhausted(content) ? (
            <Image
              src={getAwsAssets("lockIcon.svg", "content")}
              alt="lockIcon"
              height={24}
              width={24}
            />
          ) : null}

              {isContentDownloadable(content) &&
                !isVideoExhausted(content) &&
                !content.isLocked && (
                  <ContentDownloader
                    content={content}
                    handleGetOfflineDownloadList={handleGetOfflineDownloadList}
                    getOfflineDownloadedItemProgress={
                      getOfflineDownloadedItemProgress
                    }
                    getOfflineDownloadedItemState={getOfflineDownloadedItemState}
                    handleSetCheckProgressInterval={handleSetCheckProgressInterval}
                    handleClearCheckProgressInterval={
                      handleClearCheckProgressInterval
                    }
                  />
                )}

          {content?.contentType === CONTENT_TYPE.TEST &&
          !content?.isLocked &&
          (content?.numberOfAttemptsRemaining ||
            content?.numberOfAttemptsRemaining === 0) ? (
            content?.scoredMarks ||
            content?.scoredMarks === 0 ||
            (content?.typeOfTest == 2 &&
              content?.numberOfAttemptsRemaining === 0) ? (
              <React.Fragment>
                {content?.numberOfAttemptsRemaining ||
                content?.totalAttempts == -1 ? (
                  <Button
                    small
                    outline
                    onClick={() => handleAttemptTest(content)}
                  >
                    {t(
                      "components.tabs.content.components.contentList.listItem.reattemptText",
                      "Reattempt"
                    )}
                  </Button>
                ) : (
                  <div></div>
                )}
                <React.Fragment>
                  {(content?.numberOfAttemptsRemaining ||
                    content?.numberOfAttemptsRemaining === 0) &&
                  content?.typeOfTest !== 1 &&
                  content?.totalAttempts !== -1 ? (
                    <div
                      className={
                        styles.contentList__item__content__button__attempts
                      }
                    >
                      *
                      {t(
                        "components.tabs.content.components.contentList.listItem.attemptsLeftText",
                        "Attempts left"
                      )}
                      : {content?.numberOfAttemptsRemaining}
                    </div>
                  ) : null}
                  {content?.totalAttempts == -1 && (
                    <div
                      className={`${styles.contentList__item__content__button__attempts} ${styles["contentList__item__content__button__attempts--unlimited"]}`}
                    >
                      {t(
                        "components.tabs.content.components.contentList.listItem.attemptsLeftText",
                        "Attempts left"
                      )}
                      :{" "}
                      <span>
                        {t(
                          "components.tabs.content.components.contentList.listItem.unlimitedText",
                          "Unlimited"
                        )}
                      </span>
                    </div>
                  )}
                </React.Fragment>
              </React.Fragment>
            ) : content?.numberOfAttemptsRemaining ||
              content?.totalAttempts == -1 ? (
              <Button small onClick={() => handleAttemptTest(content)}>
                {t(
                  "components.tabs.content.components.contentList.listItem.attemptText",
                  "Attempt"
                )}
              </Button>
            ) : null
          ) : null}
          {content?.contentType === CONTENT_TYPE.FOLDER && (
            <Image
              className={styles.contentList__item__content__button__leftAngle}
              src={getAwsAssets("leftAngleIcon.svg", "content")}
              alt="leftAngleIcon"
              width={5}
              height={10}
            />
          )}
        </div>
      </div>
    </div>
  );
};

const ListItemDefault = React.forwardRef(ListItem);

export default ListItemDefault;
